import styled from 'styled-components'
const StyledDiv = styled.div`
  margin-bottom: 2.25rem;
`
export { StyledDiv }
